'use strict';

$(document).ready(function () {
    if ($('.category-landing').length > 0) {
        if (!sessionStorage.getItem('clpModalShown')) {
            sessionStorage.setItem('clpModalShown', 'false');
        }

        if (sessionStorage.getItem('clpModalShown') === 'false' && $('#justForYouModal').length > 0) {
            setTimeout(function () {
                $('#ckc-login-modal').modal('hide');
                $('.minicart .popover').removeClass('show');
                $('#justForYouModal').modal('show');
            }, 10000);
        }
    }
});

$('#justForYouModal').on('hidden.bs.modal', function () {
    var $carousel = $(this).find('.services-carousel-slick');
    if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
    }
});

$('#justForYouModal').on('shown.bs.modal', function () {
    var $modal = $(this);
    var $carousel = $modal.find('.services-carousel-slick');

    if ($('.header-navbar').hasClass('show-mobile-menu')) {
        $('.header-navbar').removeClass('show-mobile-menu');
    }

    $('.category-tabs-modal').each(function () {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass('d-none');
        }
    });

    if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
    }
    $carousel.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        responsive: [{
            breakpoint: 1024,
            settings: {
                centerMode: false,
                slidesToShow: 1
            }
        }]
    });

    var url = $('#closeModal').data('url');
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    sessionStorage.setItem('clpModalShown', 'true');
                }
            }
        });
    }
});
